module.exports = __webpack_public_path__ + "img/y_p3_z2.de4224d0.png";